const Waves = () => {
  return (
    <div className="m-waves">
     <div className="m-waves__container">
      <div className="m-waves__dark"></div>
      <div className="m-waves__light"></div>
    </div>
    </div>
  )
}

export default Waves